const routes = [
  {
    path: '/front',
    component: () => import('layouts/MainLayout.vue'),
    meta: { needsLocation: true },
    children: [
      {
        path: '', name: 'Home', component: () => import('pages/IndexPage.vue'),
      },
      { path: '/order', name: 'ViewOrder', component: () => import('pages/OrderPage.vue') },
      { path: '/complete', name: 'ViewOrderSummary', component: () => import('pages/CompletePage.vue') },
      { path: '/auth', name: 'Authentication', component: () => import('pages/AuthPage.vue') },
      { path: '/payment', name: 'Payment', component: () => import('pages/PaymentPage.vue') },
      { path: '/category/:codename', name: 'ViewCategory', component: () => import('pages/CategoryPage.vue') },
      { path: '/category/:codename/:productId', name: 'ViewProduct', component: () => import('pages/ProductPage.vue') },
      { path: '/page/:codename', name: 'Page', component: () => import('pages/MoyaPage.vue') },
    ],
  },

  {
    path: '/closed',
    component: () => import('layouts/ClosedLayout.vue'),
    children: [
      { path: '', name: 'closed', component: () => import('pages/ClosedPage.vue') },
    ],
  },

  {
    path: '/',
    component: () => import('layouts/ClosedLayout.vue'),
    children: [
      { path: '', name: 'Locations', component: () => import('pages/LocationSelectPage.vue') },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
